import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getNoticias } from "../services/cmsServices";
const API_BASE = process.env.REACT_APP_API_BASE;

const NoticiaDetalhe = () => {
  const { slug } = useParams();
  const [noticia, setNoticia] = useState(null);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    async function carregarNoticia() {
      try {
        setCarregando(true);
        const dados = await getNoticias();
        // Acessa a propriedade items do retorno
        const encontrada = dados.items.find(n => n.slug === slug);
        setNoticia(encontrada || null);
      } catch (error) {
        console.error("Erro ao carregar notícia:", error);
        setNoticia(null);
      } finally {
        setCarregando(false);
      }
    }

    carregarNoticia();
  }, [slug]);

  if (carregando) {
    return <div className="p-6 text-center text-gray-500">Carregando...</div>;
  }

  if (!noticia) {
    return (
      <div className="p-6 text-center text-gray-500">
        Notícia não encontrada
      </div>
    );
  }

  return (
      <section className="py-10 px-4">
      <div className="max-w-5xl mx-auto">
        {/* Título */}
        <h2 className="text-xl sm:text-2xl font-bold text-center mb-2">
          {noticia.titulo}
        </h2>
        <div className="w-24 h-1 bg-[#f6b100] mx-auto mb-6" />

        {/* Layout flexível com quebra */}
        <div className="flex flex-wrap gap-6 items-start">


          {/* Texto */}
          <div
            className="flex-1 min-w-[200px] text-sm sm:text-base text-gray-700 space-y-4 justify-html"
            dangerouslySetInnerHTML={{ __html: noticia.conteudo }}
          />
        </div>
      </div>
    </section>
  );
};

export default NoticiaDetalhe;